<div class="mt-5">Please start over</div>

<div class="buttons">
	<button type="button" mat-flat-button color="primary" (click)="introFacade.gotoLoginPage()">Login</button>
</div>
